// const SiteScan = () => import("../views/SiteScan.vue");
import SiteScan from "../views/SiteScan.vue";

export default [
    {
        path: "/SiteScan",
        name: "Site Scan",
        component: SiteScan,
        meta: {
          requiresAuth: true,
          checkPermissions: true,
          module: "site_scan",
          title: "CruzControl | Site Scan"
        }
    },
    {
        path: "/SiteScan/Chemicals/Dashboard",
        name: "Chemical Dashboard",
        component: SiteScan,
        meta: {
          requiresAuth: true,
          checkPermissions: true,
          module: "site_scan",
          feature: "chemicals",
          title: "CruzControl | Chemical Dashboard"
        }
    },
    {
        path: "/SiteScan/Chemicals/Config",
        name: "Chemical Configuration",
        component: SiteScan,
        meta: {
          requiresAuth: true,
          checkPermissions: true,
          module: "site_scan",
          feature: "chemicals",
          title: "CruzControl | Chemical Configuration"
        }
    },
    {
        path: "/SiteScan/Chemicals/Packages",
        name: "Chemical To Wash Package",
        component: SiteScan,
        meta: {
          requiresAuth: true,
          checkPermissions: true,
          module: "site_scan",
          feature: "chemicals",
          title: "CruzControl | Chemical To Wash Package"
        }
    },
    /**
     * We can add these back when we actually know what were gonna do with them.
     * {
        path: "/SiteScan/Faults",
        name: "Faults",
        component: SiteScan,
        meta: {
          requiresAuth: true,
          checkPermissions: true,
          module: "site_scan",
          feature: "faults",
          title: "CruzControl | Fault Monitoring"
        }
    },
    {
        path: "/SiteScan/Inspection",
        name: "Inspection",
        component: SiteScan,
        meta: {
          requiresAuth: true,
          checkPermissions: true,
          module: "site_scan",
          feature: "inspection",
          title: "CruzControl | Inspection"
        }
    },
    {
        path: "/SiteScan/Security",
        name: "Security",
        component: SiteScan,
        meta: {
          requiresAuth: true,
          checkPermissions: true,
          module: "site_scan",
          feature: "security",
          title: "CruzControl | Security"
        },
    },**/
]